import React from 'react';
import SendTestEmailDialog from '@shared/components/EmailsAndEcards/components/Confirm/components/SendTestEmailDailog';
import { useMobileSendTestEmailDialogController } from './MobileSendTestEmailDialog.controller';
import { useGetValidReplyToAddresses } from '@shared/components/EmailsAndEcards/components/EmailEditor/components/EmailEditPanel/hooks/getValidReplyToAddresses';

type MobileSendTestEmailDialogProps = {
  eventHandle: string;
};

const MobileSendTestEmailDialog: React.FC<MobileSendTestEmailDialogProps> = (props: MobileSendTestEmailDialogProps) => {
  const { isSendTestEmailDialogOpen, testEmail, handleSendTestEmailDialogClose, handleSendTestEmail, isMobile } = useMobileSendTestEmailDialogController();

  const allowedEmailAddresses = useGetValidReplyToAddresses(props.eventHandle);

  if (!isMobile) return null;

  return (
    <SendTestEmailDialog
      dialogId="send-test-email-dialog-ecards"
      allowedEmailAddresses={allowedEmailAddresses}
      isOpen={isSendTestEmailDialogOpen}
      onClose={handleSendTestEmailDialogClose}
      handleSendTestEmail={handleSendTestEmail}
      testEmail={testEmail}
      isMobileEmailEditor
    />
  );
};

export default MobileSendTestEmailDialog;
